<template>
	<section class="block tabs tabs-slider">
		<div class="block__headline">
			<div class="block__title w-auto headline-1">
				<i class="icon-grp-6 block__icon"></i>
				{{$t('recommendedEvents')}}
			</div>
			<div class="tab-head">
				<span class="tab-btn btn-text" :class="activeTab === 'today' ? 'active' : ''" data-target="today" @click="onChangeActiveSwiper('today')">{{ $t('cal.todays') }}</span>
				<span class="tab-btn btn-text" :class="activeTab === 'ongoing' ? 'active' : ''" data-target="ongoing" @click="onChangeActiveSwiper('ongoing')">{{ $t('cal.ongoing') }}</span>
				<span class="tab-btn btn-text" :class="activeTab === 'upcoming' ? 'active' : ''" data-target="upcoming" @click="onChangeActiveSwiper('upcoming')">{{ $t('cal.upcoming') }}</span>
				<span class="tab-btn btn-text" :class="activeTab === 'past' ? 'active' : ''" data-target="past" @click="onChangeActiveSwiper('past')">{{ $t('cal.past') }}</span>
			</div>

			<div class="block__nav">
				<NuxtLink
					to="/nft/events/"
					class="headline-3">
					{{$t('moreEvents')}}
				</NuxtLink>

				<div v-show="isShowNavigationButtons" class="block-slider__nav">
					<i
						@click="sliderPrev()"
						class="block-slider__nav-prev block__icon icon-arrow-left"
					></i>
					<i
						@click="sliderNext()"
						class="block-slider__nav-next block__icon icon-arrow-right"
					></i>
				</div>
			</div>
		</div>

        <div class="block__body">
            <div v-if="isLoading" class="block__loader">
                <LoaderQuad/>
            </div>

            <div v-show="!isLoading" class="tab-list" style="min-height: 470px">
                <div
                    class="tab-item"
                    :class="activeTab === 'today' ? 'active' : ''">
                    <Swiper
                        style="width: 100%;"
                        ref="swiper-today"
                        :slides-per-view="4"
                        :space-between="25"
                        :pagination="false"
                        :breakpoints="breakpoints"
                        :navigation="{
						nextEl: '.tabs-slider .block-slider__nav-next',
						prevEl: '.tabs-slider .block-slider__nav-prev',
					}"
                        :modules="modules"
                        @swiper="onInitSwiper($event, 'today')">
                        <SwiperSlide
                            :key="item.name + index"
                            v-for="(item, index) in events.today">
                            <BlockCardEvent :item="item"/>
                        </SwiperSlide>
                    </Swiper>
                </div>

                <div
                    class="tab-item"
                    :class="activeTab === 'ongoing' ? 'active' : ''">
                    <Swiper
                        style="width: 100%;"
                        :slides-per-view="4"
                        :space-between="25"
                        :pagination="false"
                        :breakpoints="breakpoints"
                        :navigation="{
						nextEl: '.tabs-slider .block-slider__nav-next',
						prevEl: '.tabs-slider .block-slider__nav-prev',
					}"
                        :modules="modules"
                        @swiper="onInitSwiper($event, 'ongoing')">
                        <SwiperSlide
                            :key="item.name + index"
                            v-for="(item, index) in events.ongoing">
                            <BlockCardEvent :item="item"/>
                        </SwiperSlide>
                    </Swiper>
                </div>

                <div
                    class="tab-item"
                    :class="activeTab === 'upcoming' ? 'active' : ''">
                    <Swiper
                        style="width: 100%;"
                        :slides-per-view="4"
                        :space-between="25"
                        :pagination="false"
                        :breakpoints="breakpoints"
                        :navigation="{
						nextEl: '.tabs-slider .block-slider__nav-next',
						prevEl: '.tabs-slider .block-slider__nav-prev',
					}"
                        :modules="modules"
                        @swiper="onInitSwiper($event, 'upcoming')">
                        <SwiperSlide
                            :key="item.name + index"
                            v-for="(item, index) in events.upcoming">
                            <BlockCardEvent :item="item"/>
                        </SwiperSlide>
                    </Swiper>
                </div>

                <div
                    class="tab-item"
                    :class="activeTab === 'past' ? 'active' : ''">
                    <Swiper
                        style="width: 100%;"
                        :slides-per-view="4"
                        :space-between="25"
                        :pagination="false"
                        :breakpoints="breakpoints"
                        :navigation="{
						nextEl: '.tabs-slider .block-slider__nav-next',
						prevEl: '.tabs-slider .block-slider__nav-prev',
					}"
                        :modules="modules"
                        @swiper="onInitSwiper($event, 'past')">
                        <SwiperSlide
                            :key="item.name + index"
                            v-for="(item, index) in events.past">
                            <BlockCardEvent :item="item"/>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>
        </div>
	</section>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import {useStore} from '~/stores/store';

export default {
	name: 'EventsRecommended',
	components: {
		Swiper,
		SwiperSlide,
	},
	setup() {
		const store = useStore();

		return {
			store,
			modules: [Navigation],
		}
	},
	data: () => ({
        isLoading: true,
		activeTab: 'today',
		activeSwiper: null,
		swipers: {},
		quickAccess: null,
		events: {
			today: [],
			ongoing: [],
			upcoming: [],
			past: []
		},
		breakpoints: {
			0: {
				slidesPerView: 1,
			},
			512: {
				slidesPerView: 2,
			},
			900: {
				slidesPerView: 3,
			},
			1280: {
				slidesPerView: 4,
			}
		}
	}),
	computed: {
		isShowNavigationButtons() {
			// console.log('isShowNavigationButtons()', this.activeSwiper)
			return this.activeSwiper && this.activeSwiper.slides.length > 4;
		},
	},
	async mounted() {
		// await this.fetchEvents();
		this.onChangeActiveSwiper('today');
	},
	methods: {
		onInitSwiper(swiper, tab) {
			// console.log(swiper, tab);
			this.swipers[tab] = swiper;
		},
		onChangeActiveSwiper(tab) {
			// console.log('this.$refs', this.$refs)
			this.activeTab = tab;
			this.activeSwiper = this.swipers[tab] || null;
			this.fetchEvents();
			// this.quickAccess = this.store
		},
		sliderNext() {
			if (this.activeSwiper) {
				this.activeSwiper.slideNext();
			}
		},
		sliderPrev() {
			if (this.activeSwiper) {
				this.activeSwiper.slidePrev();
			}
		},
		async fetchEvents() {
			console.log('fetchEvents()')
			if (this.swipers[this.activeTab] && this.swipers[this.activeTab].slides.length) {
				console.log('fetchEvents() empty')
				return;
			}

            try {
                this.isLoading = true;

                const api = useApi();
                const quickAccess = this.store.quick_access[this.activeTab];
                const response = await api.events.fetchRecommendedEvents({
                    quick_access: quickAccess.id
                });

                if (response) {
                    // this.events.today = [...response.results.results, ...response.results.results, ...response.results.results, ...response.results.results, ...response.results.results];
                    this.events[this.activeTab] = response.results.results;
                }
            } finally {
                this.isLoading = false;
            }
		}
	}
}
</script>
